import { useEffect } from 'react';
import { compose } from '@reduxjs/toolkit';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Error from 'core/errors/Error';
import Button from 'core/buttons/Button';
import withAppState from 'hoc/withAppState';
import PageContent from 'layouts/PageContent';

import { resetGetFundingSourceInfoFailure } from 'app/features/funding-sources-info/fundingSourceInfoSlice';

import { buildRoute } from 'routes';
import Auth from 'utils/Auth';
import FundingSourceInfoBriefDetailModal from 'components/Funding-source-info/FundingSourceInfoBriefDetailModal';
import FundingSourcesInfo from 'components/Funding-source-info/FundingSourcesInfo';
import { permissions } from 'app/data/permissions';
import { HasPermission } from 'hoc/withRole';

function ListFundingSourceInfo({ isNetworkError }) {
  const FundingSourceState = useSelector((state) => state.fundingSourcesInfo.index);

  const { isError, errorCode } = FundingSourceState;

  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (isError) dispatch(resetGetFundingSourceInfoFailure());
  }, [isNetworkError]);

  if (isError)
    return (
      <Error
        status={errorCode}
        withInDashboard={true}
        onRetry={() => dispatch(resetGetFundingSourceInfoFailure())}
      />
    );

  return (
    <PageContent
      title={
        Auth.isSuperAdmin() ? 'Partner Funding Sources Information' : 'Funding Sources Information'
      }
      rightTopEndContent={
        <HasPermission permission={permissions.CREATE_FUNDING_SOURCE_INFO}>
          <Button
            onClick={() => navigate(buildRoute('funding-sources-info.create'))}
            color="primary"
            startIcon={<AddIcon />}
          >
            Add Funding Source Information
          </Button>
        </HasPermission>
      }
    >
      <FundingSourcesInfo />
      <FundingSourceInfoBriefDetailModal />
    </PageContent>
  );
}

export default compose(withAppState)(ListFundingSourceInfo);
